// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option[data-v-308e0f32]{display:flex;justify-content:space-between;align-items:center;margin:10px 20px}", ""]);
// Exports
module.exports = exports;
